export default "__VITE_ASSET__CQ4tp_y1__"